import { formatMoney } from "./constants";
import {
  AnswerHeading,
  AnswerValue,
  BalanceDetails,
  BalanceEquation,
  DataRows,
  EquationItem,
  Explanation,
  Figure,
} from "./styles";

export function WorthAnswer() {
  const liabilityWidth = (11760 / 69000) * 100;
  const netWorthWidth = (57240 / 69000) * 100;
  const balances = [
    { name: "Bank accounts", amount: 18200 },
    { name: "Savings", amount: 14600 },
    { name: "Investments", amount: 36200 },
  ];
  const balanceRows = balances.map(({ name, amount }) => {
    const formattedAmount = formatMoney(amount);
    return (
      <div key={name}>
        <dt>{name}</dt>
        <dd>{formattedAmount}</dd>
      </div>
    );
  });
  return (
    <>
      <AnswerHeading id="worth-answer-title">
        Your whole financial picture.
      </AnswerHeading>
      <AnswerValue>
        €57,240 <span>net worth</span>
      </AnswerValue>
      <Explanation>What you own, less what you owe.</Explanation>
      <BalanceEquation aria-label="Net worth calculation">
        <EquationItem>
          <dt>Assets</dt>
          <dd>€69,000</dd>
          <Figure $width={100} />
        </EquationItem>
        <EquationItem $debt>
          <dt>Liabilities</dt>
          <dd>−€11,760</dd>
          <Figure $width={liabilityWidth} $debt />
        </EquationItem>
        <EquationItem $total>
          <dt>Net worth</dt>
          <dd>€57,240</dd>
          <Figure $width={netWorthWidth} />
        </EquationItem>
      </BalanceEquation>
      <BalanceDetails>
        <summary>See the balances behind this total</summary>
        <DataRows>
          {balanceRows}
          <div className="subtotal">
            <dt>Total assets</dt>
            <dd>€69,000</dd>
          </div>
          <div className="debt">
            <dt>Personal loan</dt>
            <dd>−€11,760</dd>
          </div>
          <div className="total">
            <dt>Net worth</dt>
            <dd>€57,240</dd>
          </div>
        </DataRows>
        <Explanation>€69,000 − €11,760 = €57,240 net worth.</Explanation>
      </BalanceDetails>
    </>
  );
}
